export type { DialogProps, Action as DialogAction } from './Dialog';
export { Dialog } from './Dialog';
